import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function EmailSent({ forgotPassword = false, changeEmail = false }) {
  // variables
  const Navigate = useNavigate();

  // functions
  const handleConfirmation = () => {
    if (changeEmail) {
      Navigate('/my-account');
      return;
    }

    Navigate('/');
  };

  return (
    <main className="d-flex w-100 h-100 login-background">
      <div className="container d-flex flex-column">
        <div className="vh-100">
          <div className="mx-auto d-table h-100 w-50">
            <div className="d-table-cell align-middle">
              <Box className="mx-auto text-center mb-3">
                <img
                  className="img-fluid mb-4"
                  width="180"
                  height="48"
                  src="/img/logo.png"
                  alt="BUILD-SELF"
                />
                <h3 className="text-bold my-3">
                  {forgotPassword && 'Password reset URL has been sent'}
                  {changeEmail && 'Email change URL has been sent'}
                  {!forgotPassword && !changeEmail && 'Verification email has been sent'}
                </h3>
                {!forgotPassword && !changeEmail && (

                  <Box
                    className="my-3"
                    sx={{
                      border: '2px solid #dc3545',
                      padding: '0.5rem',
                    }}
                  >
                    <Typography
                      fontSize={12}
                      color="#dc3545"
                    >
                      <FontAwesomeIcon icon={faCircleExclamation} className="mx-2" />
                      <span>Registration is not yet complete</span>
                    </Typography>
                  </Box>
                )}
                <Box className="card">
                  <Box className="card-body">
                    {!forgotPassword && !changeEmail && (
                      <p className="text-start">
                        A registration URL has been sent to the email address you entered.
                        <br />
                        <br />
                        If you don&apos;t receive it after a while, it may be in your spam folder or you may have entered an incorrect email address. Please check.
                        <br />
                        <br />
                      </p>
                    )}
                    {forgotPassword && (
                      <p className="text-start">
                        A password reset URL has been sent to your registered email.
                        <br />
                        <br />
                        If you don&apos;t receive it after a while, it may be in your spam folder or you may have entered an incorrect email address. Please check.
                        <br />
                        <br />
                      </p>
                    )}
                    <Button
                      sx={{
                        fontSize: '0.8rem',
                      }}
                      onClick={handleConfirmation}
                      variant="contained"
                    >
                      Back to top
                    </Button>
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default EmailSent;
